import { useEffect, useState } from "react"

import {
  getDistribuitorBuysKgsPieces,
  getDistribuitorDashboard,
  getDistribuitorDashboardEarning,
  getDistribuitorDashboardExpenses,
  getDistribuitorSalesKgsPieces,
} from "helpers/backend_helper"

import { TAB_GENERAL, TAB_PEDIDOS } from "./static"
import useTrendCard, { etiquetaPeriodo } from "./useTrendCard"
import useResumenPedidos from "./useResumenPedidos"

const CONTADORES_VACIOS = {
  orders: 0,
  clients: { active: 0, inactive: 0 },
  providers: { active: 0, inactive: 0 },
}

/**
 * Orquesta la pantalla: contadores de la cabecera, las dos tarjetas de serie
 * temporal y el margen que sale de cruzarlas.
 */
export default function useResumen() {
  const [tab, setTab] = useState(TAB_GENERAL)
  const [contadores, setContadores] = useState(CONTADORES_VACIOS)
  const [proveedores, setProveedores] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    async function cargar() {
      setIsLoading(true)
      try {
        const respuesta = await getDistribuitorDashboard({})
        setContadores(respuesta?.counters || CONTADORES_VACIOS)
        setProveedores(respuesta?.providers || [])
      } catch (error) {
        // api_helper ya notifica el error
      } finally {
        setIsLoading(false)
      }
    }

    cargar()
  }, [])

  const ventas = useTrendCard({
    cargarImporte: getDistribuitorDashboardEarning,
    cargarPiezasKgs: getDistribuitorSalesKgsPieces,
  })

  const compras = useTrendCard({
    cargarImporte: getDistribuitorDashboardExpenses,
    cargarPiezasKgs: getDistribuitorBuysKgsPieces,
  })

  const pedidos = useResumenPedidos(tab === TAB_PEDIDOS)

  return {
    state: {
      tab,
      isLoading,
      contadores,
      proveedores,
      ventas: ventas.state,
      compras: compras.state,
      pedidos: pedidos.state,
      margen: calcularMargen(ventas.state, compras.state),
    },
    events: {
      onChangeTab: setTab,
      ventas: ventas.events,
      compras: compras.events,
    },
  }
}

/**
 * Margen del periodo: ventas menos compras.
 *
 * Cada tarjeta lleva su propio periodo, así que el margen solo es comparable
 * mientras los dos coinciden. Cuando el usuario mueve uno de los dos se dice
 * qué rangos se están restando, en vez de presentar una cifra que parece del
 * mismo periodo y no lo es.
 */
export const calcularMargen = (ventas, compras) => {
  if (ventas.totalImporte === null || compras.totalImporte === null) return null

  const importe = ventas.totalImporte - compras.totalImporte

  return {
    importe,
    porcentaje:
      ventas.totalImporte > 0 ? (importe / ventas.totalImporte) * 100 : null,
    mismoPeriodo: ventas.periodo === compras.periodo,
    detalle: `Ventas ${etiquetaPeriodo(ventas.periodo)} · Compras ${etiquetaPeriodo(
      compras.periodo
    )}`,
  }
}
